import { useTranslation } from "react-i18next";
import { localDateTime } from "../../lib/datetime";
import { NeuCard } from "../../components/neu/Neu";
import { usePerms } from "../../hooks/usePerms";

export const ErrorLogs = ({ logs }) => {
  const { t } = useTranslation();
  if (!usePerms().can("support")) return null;
  return (
    <NeuCard data-testid="platform-logs">
      <p className="label-xs">{t("platform.logs")}</p>
      {logs.length === 0 ? (
        <p className="mt-4 text-sm text-muted-foreground">{t("platform.noLogs")}</p>
      ) : (
        <ul className="mt-4 space-y-2 font-mono text-xs">
          {logs.map((log) => (
            <li key={log.id} className="rounded-xl border border-border/50 px-3 py-2 shadow-neu-sm">
              <span className="text-muted-foreground">{localDateTime(log.at)}</span>{" "}
              <span className="text-destructive">
                {log.method} {log.path}
              </span>{" "}
              — {log.message}
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
